import { crc32 } from 'crc';

const RAND_BASE = (2 ** 32 - 1) / 100.0;

/**
 * Calculates whether the user is in the rollout or not using CRC
 *
 * @param name {string} rollout name
 * @param userIdentifier {string} userId or uGuid as string
 * @param percentage {number} rollout percentage
 * @param users {string[]} array of allowed users
 * @param excludedUsers {string[]} array of excluded users
 */
export const calculateRollout = (
    name: string,
    userIdentifier: string,
    percentage: number,
    users: string[],
    excludedUsers: string[]
): boolean => {
    if (excludedUsers?.includes(userIdentifier)) {
        return false;
    } else if (users.includes(userIdentifier)) {
        return true;
    }
    return crc32(userIdentifier + name) >>> 0 < RAND_BASE * percentage;
};
